import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { verifyEmail } from "src/api";


const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const navigate = useNavigate();

    const { mutate, isLoading, isError, isSuccess, data } = useMutation(verifyEmail, {
        onSuccess: (data) => {
            console.log("Verification successful:", data);
            navigate("/login"); // Redirect after success
        },
        onError: (error) => {
            console.error("Verification failed:", error);
        },
    });

    useEffect(() => {
        if (token) {
            mutate(token); // Trigger mutation when token is available
        }
    }, [token, mutate]);

    return (
        <div className="flex items-center justify-center h-screen">
            {isLoading && <p className="text-blue-500">Verifying email...</p>}
            {isSuccess && <p className="text-green-500">{data?.message || "Email verified successfully!"} 🎉</p>}
            {isError && <p className="text-red-500">Verification failed. Please try again.</p>}
        </div>
    );
};

export default VerifyEmail;
